import { type FC, type ReactNode } from 'react';
import {
  useToken,
  useDisclosure
} from '@chakra-ui/react';
import BaseRouterLink from '@/base/Router/Link';
import {
  type UiBoxProps,
  UiHStack, UiIconArrowCounterClockwise, UiIconArrowsClockwise, UiIconBell, UiIconCaretDown, UiIconDotsNine,
  UiStack, uiStyles,
} from '@/lib/ui';
import { type AppName } from './List';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import BaseLoadingSpinner from '@/base/Loading/Spinner';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { generatePageUrl } from '@/app/pages';
import BasePlainIcon from '@/base/Button/PlainIcon';
import ListDrawer from '@/base/App/ListDrawer';

export interface ListDrawerButtonProps extends UiBoxProps {
  currentApp: ReactNode
  currentAppName?: AppName
}

const ListDrawerButton: FC<ListDrawerButtonProps> = ({
  currentApp,
  currentAppName = undefined
}) => {
  const { isOpen, onToggle } = useDisclosure();
  const { tenant } = useTenantRoute();

  if (!tenant?.code) {
    return (
      <BaseLoadingSpinner />
    );
  }

  return (
    <>
      <UiHStack
        spacing={0}
        alignItems={'center'}
        flexGrow={1}
        // justifyContent={'space-between'}
        px={4}
      >
        <UiStack
          px={2}
          {...uiStyles.hover}
          onClick={onToggle}
        >
          {currentApp}
        </UiStack>
        <BasePlainIcon
          label={'Switch module'}
          Icon={UiIconArrowsClockwise}
          color={'primary.500'}
          iconSize={'xl'}
          iconWeight={'bold'}
          onClick={onToggle}
        />
        {/* <BaseRouterLink to={generatePageUrl('AccountDashboardModules', { tenantCode })} style={{ cursor: 'inherit' }}> */}
        {/*  <UiHStack */}
        {/*    borderWidth={'3px'} */}
        {/*    borderColor={'primary.500'} */}
        {/*    borderStyle={'solid'} */}
        {/*    // bgColor={'brand.500'} */}
        {/*    bgColor={'primary.500'} */}
        {/*    borderRadius={'50%'} */}
        {/*    // onClick={onToggle} */}
        {/*    p={2} */}
        {/*    {...uiStyles.hover} */}
        {/*  > */}
        {/*    <UiStack */}
        {/*      spacing={0} */}
        {/*      flexGrow={1} */}
        {/*      alignItems={'center'} */}
        {/*      justifyContent={'space-around'} */}
        {/*    > */}
        {/*      <UiIconDotsNine */}
        {/*        size={'2xl'} */}
        {/*        color={'#fff'} */}
        {/*        weight={'bold'} */}
        {/*      /> */}
        {/*    </UiStack> */}
        {/*  </UiHStack> */}
        {/* </BaseRouterLink> */}
        <ListDrawer isOpen={isOpen} onClose={onToggle} />
      </UiHStack>
    </>
  );
};

export default ListDrawerButton;
